import { useState } from "react";
import { IconButton, Input, InputAdornment, Menu, MenuItem, styled } from "@mui/material";
import AddPlaceDialog from "../../Dialogs/AddPlaceDialog";
import { usePlace } from "../../../providers/PlaceProvider";
import { useAuth } from "../../../providers/AuthProvider";
import { isAdmin } from "../../../utils/helpers";
import { Cancel } from "@mui/icons-material";

const Item = styled(MenuItem)(({ theme }) => ({
  padding: "8px 16px",
  borderRadius: 5,
  "&.active": {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
  },
  "&:hover": {
    backgroundColor: theme.palette.primary.light,
  },
}));

export function CommonPlaceChip({
  open,
  anchorEl,
  setAnchorEl,
}: {
  open: boolean;
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
}) {
  const { user } = useAuth();
  const [openDialog, setOpenDialog] = useState(false);
  const handleClose = () => setAnchorEl(null);

  const [filter, setFilter] = useState("");
  const { selectedPlace, changePlace, places } = usePlace();

  return (
    <>
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          width: 300,
          padding: "14px 8px",
          "& .MuiMenu-paper": {
            borderRadius: "6px",
            padding: "14px 8px",
            boxShadow: "-5px 5px 20px rgba(0, 0, 0, 0.07)",
          },
          "& .MuiList-root": {
            padding: 0,
          },
        }}
        transformOrigin={{ vertical: -10, horizontal: 0 }}
      >
        {isAdmin(user) && (
          <MenuItem>
            <Input
              onKeyDown={(e: React.KeyboardEvent) => e.stopPropagation()}
              onChange={(e) => setFilter(e.target.value)}
              value={filter}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={() => setFilter("")} edge="end">
                    <Cancel />
                  </IconButton>
                </InputAdornment>
              }
            />
          </MenuItem>
        )}
        {places
          .sort((a, b) => a.label.localeCompare(b.label))
          .map((place, i) => {
            const selected = selectedPlace?.id === place.id;
            if (filter.length && !place.label.toLowerCase().includes(filter.toLowerCase()))
              return null;
            return (
              <Item
                key={i}
                onClick={() => {
                  changePlace(place.id);
                  handleClose();
                }}
                className={selected ? "active" : ""}
              >
                {place.label}
              </Item>
            );
          })}
        <Item
          onClick={() => {
            setOpenDialog(true);
            handleClose();
          }}
        >
          Ajouter une enseigne
        </Item>
      </Menu>
      <AddPlaceDialog open={openDialog} setOpen={setOpenDialog} />
    </>
  );
}
